/* import __COLOCATED_TEMPLATE__ from './vision.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();